//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');

  curalate.directive('universalImageActionsProductizeEditor', [
    '$document',
    function ($document) {
      return {
        restrict: 'E',
        scope: {
          enabled: '<',
          addingProduct: '<',
          editingNewProduct: '=',
          features: '=',
          currentProduct: '<',
          trackingCategory: '@',
          isDisabled: '=',
          isCatalogConnected: '<',
          cancelEditingCallback: '&',
          updateProductCallback: '&',
          addProductCallback: '&',
          resetAddEditFlow: '&',
        },
        replace: true,
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-editor.html'),
        controller: [
          '$rootScope',
          '$scope',
          '$timeout',
          'ErrorNotificationService',
          'ImageService',
          'SessionVarsService',
          'TrackingService',
          'TrackingParamsService',
          'UniversalImageActionsItemType',
          'UniversalImageActionsApiService',
          'UniversalImageActionsService',
          function (
            $rootScope,
            $scope,
            $timeout,
            ErrorNotificationService,
            ImageService,
            SessionVarsService,
            TrackingService,
            TrackingParamsService,
            UniversalImageActionsItemType,
            UniversalImageActionsApiService,
            UniversalImageActionsService,
          ) {
            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();
            const ENTER_KEY = 13;
            let isKeypressCallbackBound = false;
            const productTypes = {
              CRAWL: 'Crawl',
              UPDATE_CRAWL: 'UpdateCrawl',
            };

            //
            // Locally bound functions
            //
            function setInitialImage() {
              if (
                !$scope.model.product.imageUrl &&
                $scope.model.product.images &&
                $scope.model.product.images.length > 0
              ) {
                const initialImage = $scope.model.product.images[0];
                updateProductImage(initialImage);
                $scope.model.originalProduct.imageUrl = initialImage.imageUrl;
              }
            }

            function initializeImageCarousel() {
              $scope.model.product.images = _.chain($scope.model.product.images)
                .uniq(false, (image) => {
                  return image.imageUrl;
                })
                .compact()
                .value();
              if (
                $scope.model.product.images &&
                $scope.model.product.images.length > 1
              ) {
                $scope.model.enableImageCarousel = true;
                $scope.model.currentImageIndex = 0;
              } else {
                $scope.model.enableImageCarousel = false;
              }
            }

            function updateProductImage(selectedImage) {
              $scope.model.product.imageUrl = selectedImage.imageUrl;
              $scope.model.product.fileId = selectedImage.fileId;
              $scope.model.product.sourceImageUrl =
                selectedImage.sourceImageUrl;
            }

            function flagProductIfUpdated() {
              if (
                $scope.model.originalProduct.name !==
                  $scope.model.product.name ||
                $scope.model.originalProduct.destinationUrl !==
                  $scope.model.product.destinationUrl ||
                $scope.model.originalProduct.imageUrl !==
                  $scope.model.product.imageUrl
              ) {
                $scope.model.product.isUpdated = true;
              }
            }

            function refreshUrlPreview(addingProduct) {
              if (_.safeGet($scope, 'model.product.destinationUrl')) {
                let paramsVersion = $scope.model.product.trackingParamsVersion
                  ? $scope.model.product.trackingParamsVersion
                  : $scope.model.latestTrackingParamsVersion;
                paramsVersion = addingProduct
                  ? $scope.model.latestTrackingParamsVersion
                  : paramsVersion;
                UniversalImageActionsApiService.getTrackingUrlPreview({
                  url: $scope.model.product.destinationUrl,
                  overrideParams: getTrackingOverrideParams(),
                  autoFills: {
                    distributionTouchpoint: 'curalate_touchpoint',
                  },
                  paramsVersionId: paramsVersion,
                }).then((trackingUrl) => {
                  $scope.model.trackingUrlPreview = trackingUrl;

                  $timeout(() => {
                    $scope.$emit('scroll-mask:adjust-mask');
                  });
                });
              }
            }

            function getTrackingSettings() {
              let trackingSettings = {
                trackingParamsVersion: null,
                trackingParamsData: null,
              };

              if ($scope.model.trackingParamsEnabled) {
                trackingSettings = {
                  trackingParamsVersion: $scope.model.trackingParamsVersion,
                  trackingParamsData: JSON.stringify({
                    overrides: getTrackingOverrideParams(),
                  }),
                };
              }

              return trackingSettings;
            }

            function getTrackingOverrideParams() {
              const overrideParams =
                UniversalImageActionsService.getOverrideParamsDiff(
                  $scope.model.originalTrackingParams,
                  $scope.model.overrideTrackingParams,
                );

              // Override parameters should not be written out with a curalateReserved since those can dynamically
              // change depending on the latest value in Tracking Parameters (whereas other tracking parameter
              // values are fixed at the given version and override parameters stored in DTS). If there was an original
              // override value that is now reserved, then it should be preserved. If it was not an overriden value that
              // is now reserved, then the url tracking service handles making sure the original value at that version
              // is still intact since it only applies the reserved parameter to previous versions non-destructively.
              const trackingParamsData = _($scope).safeGet(
                'model.product.trackingParamsData',
              );
              if (trackingParamsData) {
                const trackingParamsJson = JSON.parse(trackingParamsData);
                const originalOverrideNames = _(
                  trackingParamsJson.overrides,
                ).pluck('name');
                _(overrideParams).each((localParam) => {
                  if (
                    localParam.curalateReserved &&
                    originalOverrideNames.indexOf(localParam.name) > -1
                  ) {
                    const originalOverrideParams = _(
                      trackingParamsJson.overrides,
                    ).findWhere({ name: localParam.name });
                    localParam.value = originalOverrideParams.value;
                    localParam.autoSet = originalOverrideParams.autoSet;
                    localParam.curalateReserved = false; // An overridden parameter should never be reserved
                  }
                });
              }

              // This ensure a curalateReserved parameter is never written out as an override
              const overrideParamsFiltered = _(overrideParams).filter(
                (localParam) => {
                  return !localParam.curalateReserved;
                },
              );

              return overrideParamsFiltered;
            }

            //
            // Scope bound functions and objects
            //
            $scope.model = {
              acornBrokenImage: require('@images/acorn-broken.svg'),
              outstandingAsyncAction: null,
              editingProductName: false,
              uploader: {},
              itemType: launchOptions.getItemType(),
              trackingParamsEnabled:
                SessionVarsService.isFeatureEnabled('url_tracking_params') &&
                _($scope).safeGet('features.disableUrlEditing') !== true,
              trackingUrlPreview: '',
              editTrackingParams: false,
              originalTrackingParams: {},
              shouldShowParamsError: false,
            };

            $scope.model.uploader.onFileSelect = function ($file) {
              $scope.model.uploader.errors = [];
              $scope.model.uploader.uploadInProgress = true;
              UniversalImageActionsApiService.uploadProductImageAsync($file)
                .then((uploadedImage) => {
                  uploadedImage.imageUrl = uploadedImage.imageUrl.replace(
                    /"/g,
                    '',
                  );
                  uploadedImage.sourceImageUrl = uploadedImage.imageUrl.replace(
                    /"/g,
                    '',
                  );

                  $scope.model.enableImageCarousel = false;
                  updateProductImage(uploadedImage);

                  TrackingService.recordEvent(
                    $scope.trackingCategory,
                    TrackingService.ACTION_UPLOAD,
                  );
                })
                .catch((err) => {
                  ErrorNotificationService.showDefaultErrorDialog(
                    `We couldn't upload your image. ${err}`,
                  );
                  TrackingService.recordEvent(
                    $scope.trackingCategory,
                    TrackingService.ACTION_UPLOAD_ERROR,
                    err,
                  );
                })
                .finally(() => {
                  $scope.model.uploader.uploadInProgress = false;
                });
            };

            //
            // Events that require action from the root 'universal-image-actions-productize' directive
            //
            $scope.model.addClickedCallback = function () {
              if (!_.safeGet($scope, 'model.product.destinationUrl')) {
                return;
              }
              flagProductIfUpdated();
              $scope.addProductCallback({
                newProduct: _.extend(
                  {},
                  $scope.model.product,
                  getTrackingSettings(),
                ),
              });
            };

            $scope.model.updateClickedCallback = function () {
              if (!_.safeGet($scope, 'model.product.destinationUrl')) {
                return;
              }
              flagProductIfUpdated();
              $scope.updateProductCallback({
                updatedProduct: _.extend(
                  {},
                  $scope.model.product,
                  getTrackingSettings(),
                ),
              });
            };

            $scope.model.updateBVClickedCallback = function () {
              $scope.model.editTrackingParams = false;
              // close the editor
              $scope.resetAddEditFlow();
            };

            $scope.model.editTrackingParamsClickedCallback = function () {
              $scope.model.editTrackingParams = true;
              applyReservedTrackingParam();
            };

            $scope.model.onOverrideParamsSave = function () {
              $scope.model.editTrackingParams = false;
              refreshUrlPreview($scope.addingProduct);
            };

            $scope.model.onOverrideParamsCancel = function () {
              $scope.model.editTrackingParams = false;
            };

            //
            // Scope bound functions and objects
            //
            $scope.model.closeProductNameEditField = function () {
              $scope.model.editingProductName = false;
            };

            $scope.model.openProductNameEditField = function () {
              if ($scope.features.disableProductEditing) {
                return;
              }

              $scope.model.editingProductName = true;

              // Automatically focus on the name-edit box. This logic is required here because the 'autofocus' attribute
              // in the html only works upon the creation of an element. So closing the modal and re-opening it results
              // in the input not having focus. We clear the value and re-add it to force the cursor to the end of the textarea.
              $timeout(() => {
                const nameEditField = angular.element(
                  '.product-name-edit-field',
                );
                const existingText = nameEditField.val();
                nameEditField.focus().val('').val(existingText);
              }, 0);
            };

            $scope.model.toggleProductNameEditField = _.throttle(() => {
              $scope.model.editingProductName =
                !$scope.model.editingProductName;
            }, 250);

            //
            // Watcher for enter key presses
            //
            function keypressHandler($event) {
              if ($event.keyCode === ENTER_KEY) {
                if ($scope.editingNewProduct) {
                  $scope.$apply($scope.model.addClickedCallback);
                } else {
                  $scope.$apply($scope.model.updateClickedCallback);
                }
                angular.element(this).unbind($event);
              }
            }

            $scope.$on('$destroy', () => {
              if (isKeypressCallbackBound) {
                $document.unbind('keypress', keypressHandler);
              }
            });

            $scope.$watch('enabled', (newValue) => {
              if (newValue && !isKeypressCallbackBound) {
                $document.bind('keypress', keypressHandler);
                isKeypressCallbackBound = true;
              } else if (!newValue && isKeypressCallbackBound) {
                $document.unbind('keypress', keypressHandler);
                isKeypressCallbackBound = false;
              }
            });

            if ($scope.model.trackingParamsEnabled) {
              UniversalImageActionsApiService.getCurrentTrackingParams().then(
                (response) => {
                  $scope.model.latestTrackingParamsVersion = response.versionId;
                },
              );
            }

            function setOverrideTrackingParams() {
              $scope.model.overrideTrackingParams = angular.copy(
                $scope.model.originalTrackingParams,
              );

              const trackingParamsData = _($scope).safeGet(
                'model.product.trackingParamsData',
              );
              if (trackingParamsData) {
                const trackingParamsJson = JSON.parse(trackingParamsData);
                const overrideNames = _(trackingParamsJson.overrides).pluck(
                  'name',
                );
                _($scope.model.overrideTrackingParams.paramGroups).each(
                  (paramGroup) => {
                    _(paramGroup.params).each((params) => {
                      if (overrideNames.indexOf(params.name) > -1) {
                        const overrideParams = _(
                          trackingParamsJson.overrides,
                        ).findWhere({ name: params.name });
                        params.value = overrideParams.value;
                        params.autoSet = overrideParams.autoSet;
                        params.curalateReserved = false; // An overridden parameter should never be reserved
                      }
                    });
                  },
                );
              }

              applyReservedTrackingParam();
            }

            // This only applies the reserved tracking parameter on top of any existing parameters. It is
            // split up from setOverrideTrackingParams to allow for temporary changes to be maintained
            // if switching between updating the url (but not saving) and re-entering to re-edit
            function applyReservedTrackingParam() {
              const allOriginalParams = _(
                $scope.model.originalTrackingParams.paramGroups,
              )
                .chain()
                .pluck('params')
                .flatten()
                .value();
              const reservedParams = _(allOriginalParams).filter(
                (localParam) => {
                  return localParam && localParam.curalateReserved;
                },
              );
              const reservedNames = _.pluck(reservedParams, 'name');

              _($scope.model.overrideTrackingParams.paramGroups).each(
                (paramGroup) => {
                  _(paramGroup.params).each((params) => {
                    if (reservedNames.indexOf(params.name) > -1) {
                      params.curalateReserved = true;
                    }
                  });
                },
              );
            }

            $scope.model.selectNextImage = function () {
              if (
                $scope.model.currentImageIndex <
                $scope.model.product.images.length - 1
              ) {
                $scope.model.currentImageIndex += 1;
                updateProductImage(
                  $scope.model.product.images[$scope.model.currentImageIndex],
                );
              }
            };

            $scope.model.selectPrevImage = function () {
              if ($scope.model.currentImageIndex > 0) {
                $scope.model.currentImageIndex -= 1;
                updateProductImage(
                  $scope.model.product.images[$scope.model.currentImageIndex],
                );
              }
            };

            function handleProductEditing(newProduct) {
              $scope.model.product = angular.copy(newProduct);
              $scope.model.originalProduct = angular.copy(newProduct);
              setInitialImage();
              initializeImageCarousel();
              if ($scope.model.trackingParamsEnabled) {
                const trackingParamVersion = newProduct.trackingParamsVersion
                  ? newProduct.trackingParamsVersion
                  : $scope.model.latestTrackingParamsVersion;
                refreshParams(trackingParamVersion).then(() => {
                  setOverrideTrackingParams();
                  refreshUrlPreview($scope.addingProduct);
                });
              }
              $scope.model.product.isCrawled =
                $scope.model.product.productType &&
                ($scope.model.product.productType === productTypes.CRAWL ||
                  $scope.model.product.productType ===
                    productTypes.UPDATE_CRAWL);
            }

            function refreshParams(paramVersion) {
              return UniversalImageActionsApiService.getTrackingParametersByVersion(
                paramVersion,
              )
                .then((trackingParameters) => {
                  $scope.model.trackingParamsVersion = paramVersion;
                  const inUseParams =
                    TrackingParamsService.findInUseTrackingParams(
                      trackingParameters.trackingParams,
                    );
                  $scope.model.originalTrackingParams =
                    angular.copy(inUseParams);
                  $scope.model.shouldShowParamsError = false;
                })
                .catch(() => {
                  $scope.model.shouldShowParamsError = true;
                });
            }

            const launchProducts = launchOptions.getLaunchProducts();
            if (launchProducts.length > 0) {
              handleProductEditing(launchProducts[0]);
            }

            $scope.$onChanges = function (changesObj) {
              if (
                changesObj.currentProduct &&
                changesObj.currentProduct.currentValue
              ) {
                handleProductEditing($scope.currentProduct);
              }
            };

            function isBvProduct(product) {
              return (
                product &&
                product.productStyleId &&
                product.productStyleId.indexOf('bv_') === 0
              );
            }

            $scope.model.isBvProduct = function () {
              return isBvProduct($scope.model.product);
            };
          },
        ],
      };
    },
  ]);
})();
